import { apiClient } from '../apiClient';

type TGetUsersParams = NonNullable<
  Parameters<typeof apiClient.usersWebControllerGetList>[0]
>;

type TGetMedOrgsParams = NonNullable<
  Parameters<typeof apiClient.medorgsWebControllerList>[0]
>;

type TGetMedDevicesTypesParams = NonNullable<
  Parameters<typeof apiClient.meddeviceTypesWebControllerList>[0]
>;

type TGetMedDevicesParams = NonNullable<
  Parameters<typeof apiClient.meddevicesWebControllerList>[0]
>;

type TGetMedDeviceManufacturersParams = NonNullable<
  Parameters<typeof apiClient.manufacturersWebControllerList>[0]
>;

function tryCombineValues(key: string, params?: unknown) {
  return params ? [key, params] : [key];
}

export const QueryKeysFactory = {
  GetMedDevicesListKey: (params?: Partial<TGetMedDevicesParams>) =>
    tryCombineValues('GET_MED_DEVICES_LIST', params),

  GetMedDevicesTypesListKey: (params?: Partial<TGetMedDevicesTypesParams>) =>
    tryCombineValues('GET_MED_DEVICES_TYPES_LIST', params),

  GetMedDevicesTypeItemKey: (id?: string) =>
    tryCombineValues('GET_MED_DEVICES_TYPE_ITEM', id),

  GetAccessibleMedOrgKey: (id?: string) =>
    tryCombineValues('GET_ACCESSIBLE_MED_ORG', id),

  GetMedOrgKey: (id?: string) => tryCombineValues('GET_MED_ORG', id),

  GetMedOrgsKey: (params?: Partial<TGetMedOrgsParams>) =>
    tryCombineValues('GET_MED_ORGS', params),

  GetUsersKey: (params?: Partial<TGetUsersParams>) =>
    tryCombineValues('GET_USERS', params),

  GetDataLensControllerWebOneKey: (id?: string) =>
    tryCombineValues('DATALENS_CONTROLLER_WEB_ONE', id),

  GetDataLensControllerWebListKey: () =>
    tryCombineValues('DATALENS_CONTROLLER_WEB_LIST'),

  GetMedDeviceManufacturersListKey: (
    params?: Partial<TGetMedDeviceManufacturersParams>,
  ) => tryCombineValues('GET_MED_DEVICE_MANUFACTURERS_LIST', params),

  GetMedDeviceManufacturerKey: (id?: string) =>
    tryCombineValues('GET_MED_DEVICE_MANUFACTURER', id),
} as const;
